import styled from 'styled-components';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 40px;
  background: #f3f4f8;
  border-radius: 30px;
  width: 750px;
  height: 450px;
  overflow-y: hidden;
`;

export const AllContent = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 20px;
  padding: 20px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 20px;
`;

// export const ModuleContainer = styled.div`
//   width: 70%;
//   display: grid;
//   grid-template-columns: repeat(3, 1fr);
//   gap: 10px;
//   grid-auto-rows: minmax(40px, auto);
// `;

export const ModuleContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
`;

export const ModuleItem = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #222247;
`;

export const CheckboxHeading = styled.span`
  margin-top: 7px;
`;

// export const ModuleItemLabel = styled.div`
//   grid-column: span 3;
//   font-size: 18px;
//   font-weight: bold;
//   color: #222247;
//   margin-bottom: 10px;
// `;

export const ModuleItemLabel = styled.div`
  grid-column: span 4;
  font-size: 18px;
  font-weight: bold;
  color: #222247;
  margin-bottom: 10px;
`;

export const StatusContainer = styled.div`
  width: 30%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 20px;
  select {
    min-midth: 100%;
  }
`;

export const StatusLabel = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: #222247;
  margin-bottom: 10px;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;

  button {
    border: 1px solid #4948ac;
    border-radius: 4px;
    margin-left: 10px;
  }
`;

export const CustomCheckBox = styled.input.attrs({ type: 'checkbox' })`
  margin-right: 10px;
`;

export const UserDetailsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;

  input {
    height: 40px;
    padding: 8px 12px;
    border: 1px solid #dcdfea;
    border-radius: 4px;
    font-size: 14px;
  }
`;
